import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CourseCamp } from './course-camp';
import { StuplayConfig } from '../stuplay-config';

@Injectable()
export class CourseCampProvider {
    defaultLang: string;

    constructor(public http: HttpClient, private stuplayConfig: StuplayConfig) {}

    getCourseCamp(id: number, preview: string): Observable<CourseCamp> {
        return this.http.get(`${this.stuplayConfig.envVar.API_URL}/course-camp/${id}?preview=${preview}`)
            .pipe(map((courseCamp) => {
                return new CourseCamp(courseCamp, this.http, this.stuplayConfig);
            }));
    }

    createCourseCamp(courseCamp: any): Observable<CourseCamp> {
        return this.http.post(`${this.stuplayConfig.envVar.API_URL}/course-camp`, courseCamp)
            .pipe(map((data) => new CourseCamp(data, this.http, this.stuplayConfig)));
    }
}
